import axios from "axios";
import { getApiConfig } from "../../apiConfig";
export async function PostLogin(mail, password ) {
  try {
    const apiConfig = await getApiConfig();
    const req = `${apiConfig.BASE_URL}authorization/login`;

    const response = await axios.post(
        req,
      { mail, password }, // Datos a enviar en el cuerpo de la petición
      apiConfig.HEADERS_CONFIG // Configuración de los headers
    );
    // Manejar la respuesta
    return response.data;
  } catch (error) {
    // console.error("Error during login service:", error);
    // Manejar el error
    throw error;
  }
}
